export default __webpack_public_path__ + "static/media/access.4af910e1.jpg";